/**
 * this notification relates to if there is an action that is taken that is blocked because the
 * trade plan is already in a flattening state. (so for example, a user can't try close 10% of the position
 * that is being flattened).
 * {
	"messageType": "alertNotification",
	"notificationId": 1645221791319,
	"notificationDetails": {"errorType":"ORDER_VALIDATION","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "ALREADY_FLATTENING",
	"statusDetails": {"flatteningSymbol":"XYZ"},
	"date": "2022-02-18T17:03:12.177-0500",
	"timestamp": "1645221792177"
}

 * @param {*} statusDetails 
 * @returns obj with field:
 * 1) symbol. the symbol that is being flattened
 */
export function alreadyFlatteningParser(statusDetails) {
  const parsedObj = {
    symbol: null,
  };
  if (statusDetails) {
    parsedObj.symbol = statusDetails.flatteningSymbol ?? null;
  }
  return parsedObj;
}
